export default [
  {
    path: '/kids/test/router-list',
    component: () => import('@/views/test/RouterList.vue'),
    meta: {
      disabled: 1,
    },
  },
];
